export enum SubjectValuesEnum {
  Abstraction = 'abstraction', // Abstrakcja
  Nudes = 'nudes', // Akt
  Portraits = 'portraits', // Postać / Portret
  People = 'people', // Scena rodzajowa / Ludzie
  Landscapes = 'landscapes', // Pejzaż
  Architecture = 'architecture', // Architektura
  StillLife = 'stillLife', // Martwa natura
  Fantasy = 'fantasy',// Fantastyka
  Onirism = 'onirism', // Oniryzm
  ReligiousArt = 'religiousArt', // Sztuka sakralna
  AnimalMotives = 'animalMotives', // Motywy zwierzęce
  PlantMotives = 'plantMotives', // Motywy roślinne
  EngagedArt = 'engagedArt', // Sztuka zaangażowana
  FolkMotives = 'folkMotives', // Motywy ludowe
  ethnicMotives = 'EthnicMotives', // Motywy etniczne
  Other = 'other' // Inny
}
